.bu{flex-shrink:0;}